<template>
  <div ref="container" :class="dropdownClass+(isOpen?' active visible ':'')">
    <div @click="isOpen=!isOpen;$emit('trigger-open',isOpen)">
      <slot name="input">
        <i v-if="inputIconClass" :class="inputIconClass" style="opacity: 0.5"></i>

        <span v-if="value && !multipleSelect" class="text">{{title(value)}}</span>
        <span v-else-if="multipleSelect && selected.length">
          <div class="ui label">
            {{title(selected[0])}}
          </div>
          <div class="ui label" v-if="selected.length>1">
            +{{selected.length-1}}
          </div>
        </span>
        <span v-else class="default text">{{defText}}</span>
      </slot>
    </div>

    <div :class="menuClass + (isOpen?' transition visible':'')" :style="[isOpen?'display:block !important':'',menuStyle]">
      <slot name="content">
      </slot>
      <template v-if="categoryOptions">
        <div  v-for="(category,index) in categoryOptions" class="item" @click="openedCategory=category;$emit('change-category',category)">
          <i class="dropdown icon"></i>
          <span class="text">{{category.label}}</span>
          <div :class="'menu'+ (openedCategory==category?' transition visible':'')" :style="openedCategory==category?'display:block !important':''">
            <slot v-if="enableSearch" name="search">
              <div class="ui icon input">
                <i class="search icon"></i>
                <input type="text" placeholder="Поиск" :value="searchStr" @input="$emit('search-change',$event.target.value)">
              </div>
            </slot>
            <div class="scrolling menu" >
              <slot name="options" :options="options">
                <div v-for="(option,index) in options" :class="{selected : isSelected(option)}" class="item" @click.stop.prevent="handleClick(option)">
                  {{title(option)}}
                </div>
              </slot>

              <div v-if="emptyText&&(!options.length)" class="item">  {{emptyText}}  </div>
            </div>
          </div>
        </div>
      </template>

      <template v-else>
        <slot v-if="enableSearch" name="search">
          <div class="ui icon input">
            <i class="search icon"></i>
            <input type="text" placeholder="Поиск" :value="searchStr" @input="$emit('search-change',$event.target.value)">
          </div>
        </slot>
        <div class="scrolling menu" :style="optionsStyle">
          <slot name="options" :options="options">
            <div v-for="(option,index) in options" :class="{selected : isSelected(option)}" class="item" @click.stop.prevent="disableChange?undefined:handleClick(option)">
              {{title(option)}}
            </div>
          </slot>
          <div v-if="emptyText&&(!options.length)" class="item">  {{emptyText}}  </div>
        </div>
      </template>


    </div>
  </div>
</template>

<script>
   import {isEqual} from "lodash"
    export default {
      name: "semui-dropdown",
      props:{
        value:null,
        options:{
          type:Array,
          default:()=>[]
        },
        label:{
          type:String,
          default:"label"
        },
        dropdownClass:{
          type:String,
          default: 'ui dropdown multiple'
        },
        menuStyle:{
          type:Object,
          default:()=>({})
        },
        optionsStyle:{
          type:Object,
          default:()=>({})
        },
        menuClass:{
          type:String,
          default: 'menu'
        },
        defText:{
          type:String,
          default: "Без значения"
        },
        enableSearch:{
          type:Boolean,
          default: true
        },
        emptyText:{
          type:String,
          default: "Не найдено"
        },
        multipleSelect:{
          type:Boolean,
          default:false
        },
        maxSelectCount:{
          type:Number
        },
        categoryOptions:{
          type:Array,
        },
        searchStr:{
          type:String,
          default: ""
        },
        disableChange:{
          type:Boolean,
          default:false
        },
        inputIconClass:{
          type:String,
          default:"edit icon"
        }
      },
      // локальное состояние
      data() {
        return {
          isOpen:false,
          selected:[],
          openedCategory:null
        }
      },
      mounted() {
        document.body.addEventListener('click', this.globalClickListener)
      },
      destroyed(){
        document.body.removeEventListener('click', this.globalClickListener)
      },

      methods: {
        isSelected(option){
          if(this.multipleSelect){
            return [].concat(this.value).filter(e=>e).some(e=>option.id==e.id)
            //return this.selected.some(e=>isEqual(option,e))
            //return this.selected.indexOf(option)!==-1;
          }else{
            //return isEqual(option,this.value)//option===this.value;
            return this.value?option.id===this.value.id:false;
          }
        },
        handleClick(option){
          if(this.multipleSelect){
            //let index = this.selected.findIndex(e=>isEqual(option,e));//this.selected.indexOf(option);
            let index = this.selected.findIndex(e=>option.id==e.id);//this.selected.indexOf(option);
            if(index!==-1){
              this.selected.splice(index,1);
            }else{
              if(this.maxSelectCount
                && this.selected.length===this.maxSelectCount) return;
              this.selected.push(option);
            }
            this.$emit('input',this.selected);
          }else{
            this.$emit('input',option);
            this.isOpen=false
          }
        },
        globalClickListener(e){
          if (this.$refs.container.contains(e.target)) return;
          if (this.isOpen) this.isOpen=false;
        },
        title(value){
          return typeof value === 'object'?value[this.label]||value:value;
        },
     },
      watch:{
        value: {
          immediate:true,
          handler(nv) {
            //console.log(nv)
            if (nv && this.multipleSelect) {
              //console.log(nv)
              this.selected = nv.slice();

            }
          }
        }
      },
    }
</script>

<style scoped>

</style>
